<div *ngIf="partnerDetailEntity; else loader">
  <form
    class="partner-form"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    *transloco="let t; read: 'PAGE.PARTNER_DETAILS.FORM'"
  >
    <h2 class="layout-title">{{ t('TITLE') }}</h2>
    <div class="p-fluid grid formgrid">
      <div class="field col-12 md:col-12">
        <h5 class="partner-form-h5">{{ t('HEADER_SECTION_1_TEXT') }}</h5>
      </div>

      <div class="field col-12 md:col-12">
        <label class="partner-form-label" for="invoiceName">{{ t('INVOICE_NAME_LABEL') }}</label>
        <input
          type="text"
          pInputText
          id="invoiceName"
          [formControl]="companyNameControl"
          [readonly]="true"
        />
        <ngx-form-error [control]="companyNameControl"></ngx-form-error>
      </div>

      <div class="field col-12 md:col-2">
        <label class="partner-form-label" for="invoiceZipcode">{{ t('INVOICE_ZIPCODE_LABEL') }}</label>
        <input
          type="text"
          pInputText
          id="invoiceZipcode"
          [formControl]="zipcodeControl"
        />
        <ngx-form-error [control]="zipcodeControl"></ngx-form-error>
      </div>
      <div class="field col-12 md:col-4">
        <label class="partner-form-label" for="invoiceSettlement">{{ t('INVOICE_SETTLEMENT_LABEL') }}</label>
        <input
          type="text"
          pInputText
          id="invoiceSettlement"
          [formControl]="settlementControl"
        />
        <ngx-form-error [control]="settlementControl"></ngx-form-error>
      </div>
      <div class="field col-12 md:col-3">
        <label class="partner-form-label" for="street">{{ t('INVOICE_STREET_LABEL_NAME') }}</label>
        <input
          type="text"
          pInputText
          id="street"
          [formControl]="addressNameControl"
        />
        <ngx-form-error [control]="addressNameControl"></ngx-form-error>
      </div>
      <div class="field col-12 md:col-2 ">
        <label class="partner-form-label" for="addressType">{{ t('INVOICE_ADDRESS_TYPE_LABEL') }}</label>
        <input
          type="text"
          pInputText
          id="addressType"
          [formControl]="addressTypeControl"
        />
        <ngx-form-error [control]="addressTypeControl"></ngx-form-error>
      </div>
      <div class="field col-12 md:col-1">
        <label class="partner-form-label" for="addressNum">{{ t('INVOICE_STREET_LABEL_NUM') }}</label>
        <input
          type="text"
          pInputText
          id="addressNum"
          [formControl]="addressNumControl"
        />
        <ngx-form-error [control]="addressNumControl"></ngx-form-error>
      </div>

      <div class="field col-12 md:col-6">
        <label class="partner-form-label" for="companyRegister">{{ t('COMPANY_REGISTER_LABEL') }}</label>
        <input
          type="text"
          pInputText
          id="companyRegister"
          [formControl]="companyNumberControl"
          [readonly]="true"
        />
        <ngx-form-error [control]="companyNumberControl"></ngx-form-error>
      </div>
      <div class="field col-12 md:col-6">
        <label class="partner-form-label" for="taxNumber">{{ t('COMPANY_TAX_NUMBER_LABEL') }}</label>
        <input
          type="text"
          pInputText
          id="taxNumber"
          [formControl]="taxNumberControl"
          [readonly]="true"
        />
        <ngx-form-error [control]="taxNumberControl"></ngx-form-error>
      </div>

      <div class="field col-12 md:col-6">
        <label class="partner-form-label" for="bankName">{{ t('BANK_NAME_LABEL') }}</label>
        <input
          type="text"
          pInputText
          id="bankName"
          [formControl]="bankNameControl"
        />
      </div>
      <div class="field col-12 md:col-6">
        <label class="partner-form-label" for="bankAccountNumber">{{ t('BANK_ACCOUNT_NUMBER_LABEL') }}</label>
        <input
          type="text"
          pInputText
          id="bankAccountNumber"
          [formControl]="invoiceNumberControl"
        />
      </div>

      <div class="field col-12 md:col-12">
        <h5 class="partner-form-h5">{{ t('HEADER_SECTION_2_TEXT') }}</h5>
      </div>

      <div class="field col-12 md:col-12">
        <p-dropdown
          [showClear]="true"
          optionLabel="place_name"
          placeholder="Beváltóhely kiválasztása"
          [(ngModel)]="selectedRedeemablePlace"
          [ngModelOptions]="{ standalone: true }"
          [options]="partnerDetailEntity!.redeemable_places"
        >
        </p-dropdown>
      </div>

      <ng-container *ngIf="selectedRedeemablePlace">
        <!-- <div class="field col-12 md:col-12">
          <label class="partner-form-label" for="place">{{ t('REDEEMABLE_PLACE_TEXT') }}</label>
          <input
            type="text"
            pInputText
            id="place"
            [(ngModel)]="selectedRedeemablePlace.place_name"
            [ngModelOptions]="{ standalone: true }"
            [readonly]="true"
          />
        </div> -->

        <div class="field col-12 md:col-2">
          <label class="partner-form-label" for="postcode">{{ t('INVOICE_ZIPCODE_LABEL') }}</label>
          <input
            type="text"
            pInputText
            id="postcode"
            [(ngModel)]="selectedRedeemablePlace.zipcode"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label class="partner-form-label" for="city">{{ t('INVOICE_SETTLEMENT_LABEL') }}</label>
          <input
            type="text"
            pInputText
            id="city"
            [(ngModel)]="selectedRedeemablePlace.city"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label class="partner-form-label" for="addressName">{{ t('INVOICE_STREET_LABEL_NAME') }}</label>
          <input
            type="text"
            pInputText
            id="addressName"
            [(ngModel)]="selectedRedeemablePlace.address_name"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
        <div class="field col-12 md:col-2">
          <label class="partner-form-label" for="addressNum">{{ t('INVOICE_STREET_LABEL_NUM') }}</label>
          <input
            type="text"
            pInputText
            id="addressNum"
            [(ngModel)]="selectedRedeemablePlace.address_num"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>

        <div class="field col-12 md:col-3">
          <label class="partner-form-label" for="phone">{{ t('REDEEMABLE_PHONE_LABEL') }}</label>
          <input
            type="text"
            pInputText
            id="phone"
            [(ngModel)]="selectedRedeemablePlace.tel_number"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
        <div class="field col-12 md:col-4">
          <label class="partner-form-label" for="email">{{ t('REDEEMABLE_EMAIL_LABEL') }}</label>
          <input
            type="text"
            pInputText
            id="email"
            [(ngModel)]="selectedRedeemablePlace.email"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
        <div class="field col-12 md:col-5">
          <label class="partner-form-label" for="web">{{ t('REDEEMABLE_WEBSITE_LABEL') }}</label>
          <input
            type="text"
            pInputText
            id="web"
            [(ngModel)]="selectedRedeemablePlace.website"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
        <div class="field col-12 md:col-7">
          <label class="partner-form-label" for="gpsCoordinates">{{ t('REDEEMABLE_GPS_COORDINATES_LABEL') }}</label>
          <input
            type="text"
            pInputText
            id="gpsCoordinates"
            [ngModel]="selectedRedeemablePlace.gps_coordinates"
            [ngModelOptions]="{ standalone: true }"
            [readonly]="true"
          />
        </div>
      </ng-container>
    </div>

    <div class="partner-form-actions">
      <button
        pButton
        pRipple
        type="button"
        class="p-button-rounded p-button-outlined"
        [routerLink]="['/user', 'change-password']"
      >
        {{ t('PASSWORD_CHANGE_BUTTON_LABEL') }}
      </button>
      <button
        pButton
        pRipple
        type="submit"
        class="p-button-rounded"
        [label]="t('SAVE_BUTTON_LABEL')"
      ></button>
    </div>
  </form>
</div>

<ng-template #loader>
  <div class="centered">
    <p-progressSpinner></p-progressSpinner>
  </div>
</ng-template>

<p-toast key="partner-details"></p-toast>
